import React from 'react';
import { Icon, IconProps } from './Icon';

export const Edit: React.FC<IconProps> = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m239.43 826.67 533.99-534.03c17.28-2.38 34.63-.9 50.83 4.03 18.29 5.58 35.32 15.7 49.43 29.81 14.11 14 24.19 31.07 29.77 49.39 4.93 16.2 6.37 33.55 4 50.87l-534.03 533.92c-1.15-6.23-2.66-12.38-4.5-18.43-7.88-25.81-22-49.79-41.65-69.41-19.51-19.62-43.49-33.77-69.45-41.65-6.05-1.84-12.2-3.35-18.4-4.5zm580.22-580.29 34.2-34.2c18.21-17.6 42.05-26.43 65.88-26.43s48.64 9.18 67 27.54c18.4 18.47 27.61 42.77 27.61 67.07.11 24.27-9.14 48.6-27.54 67.07l-33.09 33.05c-1.15-6.27-2.66-12.42-4.5-18.5-7.88-25.81-22-49.79-41.65-69.41-19.51-19.62-43.49-33.77-69.45-41.65-6.05-1.84-12.2-3.35-18.47-4.5v-.04zm-491.48 750.25-139.5 14.76 14.76-139.5c13.82-.68 27.54 1.04 40.53 5 18.29 5.58 35.32 15.7 49.43 29.81 14.11 14 24.19 31.07 29.77 49.39 3.96 12.96 5.65 26.71 5 40.53zm-170.46-147.46-19.77 186.7c-.14 1.59-.18 3.2 0 4.86 1.33 13.14 13.1 22.71 26.25 21.38l186.3-19.73 1.08-.07h.04c5.47-.47 10.77-2.73 14.94-6.91l654.08-654.08c27.68-27.79 41.58-64.41 41.54-100.95.11-36.54-13.79-73.15-41.58-100.95-27.9-27.79-64.44-41.65-100.95-41.65s-71.82 13.43-99.43 40.29l-1.48 1.37-654.12 654.08c-4.03 4.36-6.59 9.14-6.95 15.66h.04z" />
    </Icon>
  );
};
